<div class="container">
  <div class="row mt-2 ml-1 ">

    <!-- Search Bar -->
    <div class="col-md-4 d-flex align-items-center search-bar">
      <img class="icon" src="/assets/svg/search_bar.svg" alt="search" />
      <input type="search" class="search-input" placeholder="Search" (input)="onSearchInput($event.target.value)" />
    </div>


    <!-- Status filter -->
    <div class="col-md-4 status">
      <button class="btn-1" [ngClass]="{ 'blue': isAll }" (click)="All()">
        All
      </button>
      <button class="btn-1" [ngClass]="{ 'blue': isOpen }" (click)="Open()">
        Open
      </button>
      <button class="btn-1" [ngClass]="{ 'blue': isClose }" (click)="Close()">
        Close
      </button>

      <!-- Stage Filter -->
      <div class="mat-form-field-capabilities">
        <mat-form-field appearance="outline" class="example-full-width">
          <mat-label>
            <img src="\assets\svg\filter-icon.svg" />
            <span class="common-heading"> Stage</span>
          </mat-label>
          <mat-select [(ngModel)]="stageSearch" (selectionChange)="onFiltreChange()">
            <mat-option *ngFor="let stage of stages" [value]="stage">
              <div class="options" #stag [matTooltip]="stage | underScoreToSpace" [matTooltipPosition]="position.value"
                [matTooltipClass]="position.value" [matTooltipDisabled]="!ifOverflow(stag)">
                {{ stage | underScoreToSpace }}
              </div>
            </mat-option>

          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <!-- year filter and pagination-->
    <div class="col-4 d-flex align-items-center justify-content-between flex-nowrap filter-pagination">
      <!-- Year filter -->
      <div class="year-filter me-2" style="margin-bottom: 2px;">
        <mat-form-field appearance="outline" class="example-full-width" style="width:150px;">
          <mat-label>
            <img src="\assets\svg\filter-icon.svg" />
            <span class="common-heading"> Year</span>
          </mat-label>
          <mat-select [(ngModel)]="yearSearch" (selectionChange)="onFiltreChange()">
            <mat-option *ngFor="let year of years" [value]="year">
              {{ year }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <!-- Pagination -->
      <div class="pagination-wrapper">
        <pagination-controls class="pagination-controls" [maxSize]="5" [directionLinks]="true"
          (pageChange)="onPageChange($event)" previousLabel="<" nextLabel=">">
        </pagination-controls>
      </div>
    </div>
  </div>
</div>
<div class="container-fluid mt-2 display">
  <div *ngIf="!isSpinnerActive" class="container">
    <div class="mt-3 row">
      <div class="table-responsive">
        <table class="table table-striped text-center">
          <thead>
            <tr>
              <th>Raised By</th>
              <th class="raised-by-col">Title</th>
              <th>ID</th>
              <th>Date</th>
              <th>Status</th>
              <th>Stage</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="let issue of issues| paginate : { itemsPerPage: this.pageSize, totalItems: this.totalPages * pageSize, currentPage: page }"
              (click)="onClick(issue.id)">
              <td>
                <div class="align-items-center justify-content-center" [matTooltip]="issue.createdByName"
                  [matTooltipPosition]="position.value" [matTooltipClass]="position.value">
                  <img class="avatar" [src]="getUserImage(issue.createdByImage)" alt="Avatar" />
                  <span class="ml-2 ">{{ issue.createdByName }}</span>
                </div>
              </td>
              <td class="title-col raised-by-col">
                <div class="title-text  mt-1">{{ issue.shortSummary }}</div>
              </td>
              <td>
                <div class="mt-1" [matTooltip]="issue.bugId "
                  [matTooltipPosition]="position.value" [matTooltipClass]="position.value">{{ issue.bugId }}</div>
              </td>
              <td>
                <div class="mt-1" [matTooltip]="issue.modifiedDate.slice(0,10) "
                  [matTooltipPosition]="position.value" [matTooltipClass]="position.value">{{ issue.modifiedDate.slice(0,10) }}</div>
              </td>
              <td>
                <div class="mt-1" [matTooltip]="issue.status ? 'Close' : 'Open'  "
                  [matTooltipPosition]="position.value" [matTooltipClass]="position.value">{{ issue.status ? 'Close' : 'Open' }}</div>
              </td>
              <td>
                <div class="mt-1" [matTooltip]="issue.stage | underScoreToSpace"
                  [matTooltipPosition]="position.value" [matTooltipClass]="position.value">{{ issue.stage | underScoreToSpace }}</div>
              </td>
              <td>
               <label
                  class="data" style="cursor: pointer" >
                  <img src="assets/icons/3dots.png" class="threedots" />
                </label>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <div *ngIf="isSpinnerActive" class="spinner-div">
    <div class="spinner-border" role="status">
      <span class="sr-only">Loading...</span>
    </div>
    <label class="loading_label">Loading...</label>
  </div>
  <div *ngIf="!isSpinnerActive && issues.length===0" class="spinner-div">
    <label class="loading_label">No issues available !</label>
  </div>
</div>
